module.exports = __webpack_public_path__ + "assets/cloudfront.b10a413a.svg";